import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {FormModel} from '../model/forms/form-model';
import {InputModel} from '../model/forms/input-model';
import {Ftp} from '../model/ftp';
import {CreateObjectDialogComponent} from '../createObjectDialog/create-object-dialog.component';
import {ServerConfig} from '../model/ServerConfig';
import {SmsConfig} from '../model/smsConfig';
import {FacebookAPIConfig} from '../model/FacebookAPIConfig';
import {ProjectService} from '../project/project.service';
import {MailConfig} from '../model/mailConfig';
import {TwitterAPIConfig} from '../model/TwitterAPIConfig';
import {Twitter} from '../model/social-sharing/twitter';
import {GenericModalComponent} from '../modal/generic-modal.component';
import {NotepadComponent} from '../notepadApp/notepad.component';

@Component({
  selector:'control-panel',
  template:`
    <nav class="navbar navbar-expand-sm navbar-dark bg-dark">
      <a class="navbar-brand" href="#">
        <img src="https://getbootstrap.com/docs/4.3/assets/brand/bootstrap-solid.svg" width="30" height="30" class="d-inline-block align-top" alt="">
        JuJu
      </a>
      <button class="navbar-toggler" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
        </ul>
        <form class="form-inline my-2 my-lg-0">
          <ul class="navbar-nav mr-auto">
            <!--<button class="btn btn-outline-primary" (click)="dashboard()" data-toggle="tooltip" data-placement="bottom" title="Dashboard"><span><i class="fas fa-tachometer-alt"></i></span></button>-->
            <button class="btn btn-outline-primary" (click)="dashboard()" data-toggle="tooltip" data-placement="bottom" title="Dashboard">
              <img src="../../assets/images/Dashboard-icon.png" width="24" height="24"/>
            </button>
          </ul>
          <ul class="navbar-nav mr-auto">
            <!--<button class="btn btn-outline-info" (click)="home()" data-toggle="tooltip" data-placement="bottom" title="Dashboard"><span><i class="fas fa-home"></i></span></button>-->
            <button class="btn btn-outline-info my-2 my-sm-0" (click)="home()" data-toggle="tooltip" data-placement="bottom" title="Dashboard">
              <img src="../../assets/images/Home-icon.png" width="24" height="24"/>
            </button>
          </ul>
        </form>
      </div>
    </nav>
    <div class="panel panel-default" style="padding: 10px;">
      <div class="row">
        <div class="col card" style="padding: 10px;">
          <div class="card-body">
            <div class="w3-card-4">
              <header class="w3-container" style="background:linear-gradient(0deg,rgba(59,139,239,1) 0%,rgba(11,97,206,1) 100%);border-top-left-radius:5px;border-top-right-radius:5px;">
                <h4><span><img style="width:40px;height:40px;" src="../../assets/images/100.png"></span>Control Panel</h4>
                <div class="w3-padding w3-xlarge w3-text-white">
                </div>
              </header>
              <div class="w3-container">
                <div>
                  <span><img alt="Control-Panel" src="../../assets/images/100.png" style="width: 100px;height:100px;margin-left: 15px;"></span>
                </div>
                <br/>
                <div class="card" style="margin-right:15px;margin-left:15px;">
                  <h5 class="card-header">User and Admin</h5>
                  <div class="card-body">
                    <div>
                      <button class="w3-button w3-white w3-border w3-border-blue" title="Users and account"><img alt="ftp" src="../../assets/images/075.png" style="width:100px;height:100px;"></button>
                    </div>
                  </div>
                </div>
                <br/>
                <div class="card" style="margin-right:15px;margin-left:15px;">
                  <h5 class="card-header">Connections</h5>
                  <div class="card-body">
                    <div>
                      <div class="button-row">
                        <button class="w3-button w3-white w3-border w3-border-blue" title="Configure FTP for backup" (click)="getConfiguration('ftp')"><img alt="ftp" src="../../assets/images/ftp.png" style="width:100px;height:100px;"></button>
                        <button class="w3-button w3-white w3-border w3-border-blue" title="Configure Cloud Media Drive"><img alt="ftp" src="../../assets/images/cloud.png" style="width:100px;height:100px;"></button>
                      </div>
                    </div>
                  </div>
                </div>
                <br/>
                <div class="card" style="margin-right:15px;margin-left:15px;">
                  <h5 class="card-header">Social Sharing and  API</h5>
                  <div class="card-body">
                    <div>
                      <div class="button-row">
                        <button class="w3-button w3-white w3-border w3-border-blue" title="Facebook API Configuration" (click)="getConfiguration('facebook')"><img alt="ftp" src="../../assets/images/facebook-icon-png-blue.png" style="width:100px;height:100px;"></button>
                        <button class="w3-button w3-white w3-border w3-border-blue" title="Twitter API Configuration" (click)="getConfiguration('twitter')"><img alt="ftp" src="../../assets/images/circle-twitter-512.png" style="width:100px;height:100px;"></button>
                        <button class="w3-button w3-white w3-border w3-border-blue" title="Twillio API Configuration" (click)="getConfiguration('sms')"><img alt="ftp" src="../../assets/images/437.png" style="width:100px;height:100px;"></button>
                        <button class="w3-button w3-white w3-border w3-border-blue" title="Mail Configuration"><img alt="ftp" src="../../assets/images/mailSettings.png" style="width:100px;height:100px;"></button>
                      </div>
                    </div>
                  </div>
                </div>
                <br/>
                <div class="card" style="margin-right:15px;margin-left:15px;">
                  <h5 class="card-header">Server Configuration</h5>
                  <div class="card-body">
                      <div class="button-row">
                        <button class="w3-button w3-white w3-border w3-border-blue" title="Server Configuration Configuration" (click)="getConfiguration('server')"><img alt="ftp" src="../../assets/images/server.png" style="width:100px;height:100px;"></button>
                        <button class="w3-button w3-white w3-border w3-border-blue" title="Server Spring Log File" (click)="getSpringLog('spring')"><img alt="ftp" src="../../assets/images/logIcon.png" style="width:100px;height:100px;"></button>
                        <button class="w3-button w3-white w3-border w3-border-blue" title="Server Standard Main Log File" (click)="getSpringLog('standard')"><img alt="ftp" src="../../assets/images/notepad.png" style="width:100px;height:100px;"></button>
                      </div>
                  </div>
                </div>
                <br/>
              </div>
              <footer class="w3-container w3-blue">
                <h5></h5>
              </footer>
            </div>
          </div>
        </div>
      </div>
    </div>
    <create-object-dialog (NewObjectEvent)="onNewEvent($event)"  [modelObject]="intentModel" [formModel]="formModel" [wizardTitle]="formModel.title"></create-object-dialog>
    <generic-info-modal [hide]="_hideInfoModal" [title]="_genericModalTitle" [text]="_genericModalText"
                        (OkClick)="onOk()"></generic-info-modal>
    <notepad [text]="_log" [logType]="_logType"></notepad>
  `,
  styles:[`
  .titleBar{height:25px;background-image: linear-gradient(to right, #e5e0d3 0%, #e6e0d3 100%);border-bottom:1px;}
  .category{border-bottom:#dadfe1;border-style: solid;border-width:1px; }
  .category:nth-child(even){background-color: #e2e5e6;height:160px;}
  .category:nth-child(odd){background-color: #ececec;height:160px;}
  .item{width:70px;height: 70px;background-color: #00b0ff; margin-left: 20px;float: left;}

  * {
    outline: none;
  }
  h4{text-align: center;color:#ffffff;margin-top:20px;}
    ul{margin-left: 5px;}

    .button-row button:nth-child(even){margin-left:20px;}
    .button-row button:nth-child(3n){margin-left:20px;}
  `]
})

export class ControlPanelComponent implements OnInit {

  private formModel:FormModel;

  private intentModel:(Ftp|ServerConfig|SmsConfig|FacebookAPIConfig|TwitterAPIConfig);

  private _hideInfoModal=true;

  private _genericModalTitle:string;

  private _genericModalText:string;

  private _log:string;

  private _logType:string;



  @ViewChild(CreateObjectDialogComponent) private createObjectDialogueComponent:CreateObjectDialogComponent;
  @ViewChild(GenericModalComponent) private genericComponent:GenericModalComponent;
  @ViewChild(NotepadComponent) private notepadComponent:NotepadComponent;

  constructor(private _router:Router,private _projectService:ProjectService) {}

  ngOnInit(): void {
    this.formModel = this.generateFTPForm();
    this.intentModel = new Ftp('');
  }


  dashboard() {
    this._router.navigate(['dashboard']);
  }

  home() {
    this._router.navigate(['main']);
  }

  private configureFTPDialog(ftpConfig:Ftp) {

    this.intentModel = ftpConfig;
    this.formModel = this.generateFTPForm();
    for(const input of this.formModel.inputs) {
      switch(input.name.get('en')) {
        case 'ServerIP': input.value = ftpConfig.FtpServerIP;break;
        case 'Server Port': input.value = ftpConfig.Port;break;
        case 'ClientUsername': input.value = ftpConfig.Username;break;
        case 'ClientPassword': input.value = ftpConfig.Password;break;
      }
    }
    this.createObjectDialogueComponent.toggleDialog();
  }

  private configureServerDialog(srvConfig:ServerConfig) {

    this.intentModel = srvConfig;
    this.formModel = this.generateServerConfigForm();
    this.createObjectDialogueComponent.toggleDialog();
    for(const input of this.formModel.inputs) {
      switch(input.name.get('en')) {
        case 'ServerIP':input.value = srvConfig.ipAddress;break;
        case 'Server Port':input.value = srvConfig.port;break;
      }
    }
  }

  private configureSmsDialog(smsConfiguration:SmsConfig) {

    this.intentModel = smsConfiguration;
    this.formModel = this.generateSmsConfigForm();
    this.createObjectDialogueComponent.toggleDialog();
    for(const input of this.formModel.inputs) {
      switch(input.name.get('en')) {
        case 'accountSid': input.value = smsConfiguration.accountSid;break;
        case 'authToken': input.value = smsConfiguration.authToken;break;
        case 'fromNumber': input.value = smsConfiguration.fromNumber;break;
        case 'testNumber': input.value = smsConfiguration.testNumber;break;
        case 'maxShare': input.value = smsConfiguration.maxShare;break;
        case 'until': input.value = smsConfiguration.until;break;
      }
    }
  }

  private configureFacebookAPIDialog(facebookConfig:FacebookAPIConfig) {

    this.formModel = this.generateFacebookAPIConfigForm();
    this.intentModel = facebookConfig;
    this.createObjectDialogueComponent.toggleDialog();
    for(const input of this.formModel.inputs) {
      switch(input.name.get('en')) {
        case 'apiKey': input.value = facebookConfig.ApiKey;break;
      }
    }
  }

  private configureTwitterKEYDialog(twitterConfig:TwitterAPIConfig) {

    this.formModel = this.generateTwitterAPIConfigForm();
    this.intentModel = twitterConfig;
    this.createObjectDialogueComponent.toggleDialog();
    for(const input of this.formModel.inputs) {
      switch(input.name.get('en')) {
        case 'consumerKey': input.value = twitterConfig.consumerKey;break;
        case 'consumerSecretKey': input.value = twitterConfig.consumerSecretKey;break;
      }
    }
  }

  private getConfiguration(configType:string):string {
    let json = '';
    this._projectService.getConfiguration(configType).subscribe((next:any) => {

      json = next;
      switch(configType) {
        case 'server': this.configureServerDialog(new ServerConfig(json));break;
        case 'ftp': this.configureFTPDialog(new Ftp(json));break;
        case 'sms': this.configureSmsDialog(new SmsConfig(json));break;
        case 'mail': this.configureMailDialog(new MailConfig(json));break;
        case 'facebook': this.configureFacebookAPIDialog(new FacebookAPIConfig(json));break;
        case 'twitter': this.configureTwitterKEYDialog(new TwitterAPIConfig(json));break;
      }
      // console.log('HTTP Status: -> ' +next);
    });
    return json;

  }

  onNewEvent(event: string) {
    switch (event) {
      case 'ftp':this.genericComponent.defineModal('FTP Configuration was saved successfully.','FTP Configuration',200);this._hideInfoModal=false;break;
      case 'serverConfig':this.genericComponent.defineModal('Server Setting were saved successfully.','Server Configuration',200);this._hideInfoModal=false;break;
      case 'smsConfig':this.genericComponent.defineModal('Twillio settings saved successfully.','Twillio/SMS Configuration',200);this._hideInfoModal=false;break;
      case 'mailConfig':this.genericComponent.defineModal('Mail settings saved successfully.','Mail Configuration',200);this._hideInfoModal=false;break;
      case 'facebookConfig':this.genericComponent.defineModal( 'Facebook API KEY was saved successfully.','Facebook API Configuration',200);this._hideInfoModal=false;break;
      case 'twitterConfig':this.genericComponent.defineModal( 'Twitter API KEY was saved successfully.','Twitter API Configuration',200);this._hideInfoModal=false;break;
    }

  }

  private onOk() {
    this._hideInfoModal = true;
  }

  private  generateServerConfigForm():FormModel {
      const inputIP = new InputModel();
      inputIP.type = 'text';
      inputIP.label.set('en','Server IP');
      inputIP.validation.set('required','true');
      inputIP.placeholder.set('en','IP address');
      inputIP.name.set('en','ServerIP');

      const inputPort = new InputModel();
      inputPort.type = 'text';
      inputPort.label.set('en','Port');
      inputPort.validation.set('required','true');
      inputPort.placeholder.set('en','Port');
      inputPort.name.set('en','Server Port');

    const form = new FormModel();
    form.title = 'Configure Server IP';
    form.inputs.push(inputIP);
    form.inputs.push(inputPort);

    return form;
  }

  private  generateFacebookAPIConfigForm():FormModel {
    const inputAPIKey = new InputModel();
    inputAPIKey.type = 'text';
    inputAPIKey.label.set('en','API Key');
    inputAPIKey.validation.set('required','true');
    inputAPIKey.placeholder.set('en','API Key');
    inputAPIKey.name.set('en','apiKey');

    const form = new FormModel();
    form.title = 'Configure Facebook API KEY';
    form.inputs.push(inputAPIKey);

    return form;
  }

  private  generateTwitterAPIConfigForm():FormModel {
    const inputAPIKey = new InputModel();
    inputAPIKey.type = 'text';
    inputAPIKey.label.set('en','Consumer Key');
    inputAPIKey.validation.set('required','true');
    inputAPIKey.placeholder.set('en','Consumer Key');
    inputAPIKey.name.set('en','consumerKey');

    const inputSecretKey = new InputModel();
    inputSecretKey.type = 'text';
    inputSecretKey.label.set('en','Consumer Secret Key');
    inputSecretKey.validation.set('required','true');
    inputSecretKey.placeholder.set('en','Consumer Secret Key');
    inputSecretKey.name.set('en','consumerSecretKey');

    const form = new FormModel();
    form.title = 'Configure Twitter API';
    form.inputs.push(inputAPIKey);
    form.inputs.push(inputSecretKey);

    return form;
  }


  private  generateSmsConfigForm():FormModel {
    const inputSid = new InputModel();
    inputSid.type = 'text';
    inputSid.label.set('en','Account SID');
    inputSid.validation.set('required','true');
    inputSid.placeholder.set('en','Account SID');
    inputSid.name.set('en','accountSid');

    const authToken = new InputModel();
    authToken.type = 'text';
    authToken.label.set('en','Authentication Token');
    authToken.validation.set('required','true');
    authToken.placeholder.set('en','Authentication Token');
    authToken.name.set('en','authToken');

    const fromNumber = new InputModel();
    fromNumber.type = 'text';
    fromNumber.label.set('en','From Number');
    fromNumber.validation.set('required','true');
    fromNumber.placeholder.set('en','From Number');
    fromNumber.name.set('en','fromNumber');

    const testNumber = new InputModel();
    testNumber.type = 'text';
    testNumber.label.set('en','Test Number');
    testNumber.validation.set('required','true');
    testNumber.placeholder.set('en','Test Number');
    testNumber.name.set('en','testNumber');

    const maxShare = new InputModel();
    maxShare.type = 'text';
    maxShare.label.set('en','Maximum Share');
    maxShare.validation.set('required','true');
    maxShare.placeholder.set('en','Maximum Share');
    maxShare.name.set('en','maxShare');

    const until = new InputModel();
    until.type = 'text';
    until.label.set('en','Expiry Date');
    until.validation.set('required','true');
    until.placeholder.set('en','eg:30/05/2113');
    until.name.set('en','until');

    const form = new FormModel();
    form.title = 'Configure Twillio API';
    form.inputs.push(inputSid);
    form.inputs.push(authToken);
    form.inputs.push(fromNumber);
    form.inputs.push(testNumber);
    form.inputs.push(maxShare);
    form.inputs.push(until);
    return form;
  }


  private generateFTPForm():FormModel {

    const inputIP = new InputModel();
    inputIP.type = 'text';
    inputIP.label.set('en','Server IP');
    inputIP.validation.set('required','true');
    inputIP.placeholder.set('en','IP address');
    inputIP.name.set('en','ServerIP');

    const inputPort = new InputModel();
    inputPort.type = 'text';
    inputPort.label.set('en','Port');
    inputPort.validation.set('required','true');
    inputPort.placeholder.set('en','Port');
    inputPort.name.set('en','Server Port');

    const inputUsername = new InputModel();
    inputUsername.type = 'text';
    inputUsername.label.set('en','Username');
    inputUsername.validation.set('required','true');
    inputUsername.placeholder.set('en','Client Username');
    inputUsername.name.set('en','ClientUsername');

    const inputPassword = new InputModel();
    inputPassword.type = 'password';
    inputPassword.label.set('en','Password');
    inputPassword.validation.set('required','true');
    inputPassword.placeholder.set('en','Client Password');
    inputPassword.name.set('en','ClientPassword');

    const form = new FormModel();
    form.title = 'Configure FTP Server For Backup';
    form.inputs.push(inputIP);
    form.inputs.push(inputPort);
    form.inputs.push(inputUsername);
    form.inputs.push(inputPassword);

    return form;
  }

  private configureMailDialog(mailConfig: MailConfig) {

    this.createObjectDialogueComponent.toggleDialog();
  }

  getSpringLog(log: string) {
   /* this._projectService.getLogs(log).subscribe( res => {

      this._logType = log;
      if(res!=='204') {
        this._log = res;*/
        // this.no = 'Logs';
      this._logType=log;
        this.notepadComponent.toggleDialog();
        // this.createObjectDialogueComponent.toggleDialog();
      /*}
    });*/

  }
}
